var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27370",
    "data-name": "Group 27370",
    transform: "translate(8523 -9975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6211",
    "data-name": "Rectangle 6211",
    transform: "translate(-8523 9975)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_57",
    "data-name": "Union 57",
    d: "M-15518.316-24777.947a1.677,1.677,0,0,1-1.443-.834,1.668,1.668,0,0,1-.037-1.668l5.369-9.7a1.657,1.657,0,0,1,1.475-.852,1.66,1.66,0,0,1,1.481.852l5.369,9.7a1.668,1.668,0,0,1-.037,1.668,1.671,1.671,0,0,1-1.444.834Zm5.016-11.578-5.37,9.693a.42.42,0,0,0-.006.41.4.4,0,0,0,.36.193h10.732a.391.391,0,0,0,.361-.193.42.42,0,0,0-.006-.41l-5.37-9.693a.416.416,0,0,0-.354-.225A.407.407,0,0,0-15513.3-24789.525Zm-.467,8.684a.818.818,0,0,1,.814-.814.819.819,0,0,1,.821.814.82.82,0,0,1-.821.816A.818.818,0,0,1-15513.768-24780.842Zm.36-1.8a.665.665,0,0,1-.187-.455v-3.465a.644.644,0,0,1,.635-.652h.006a.642.642,0,0,1,.454.186.659.659,0,0,1,.193.467v3.465a.645.645,0,0,1-.647.641A.632.632,0,0,1-15513.407-24782.639Z",
    transform: "translate(6997.949 34767.473)",
    fill: "#314469"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.1e6a6facf970fd271e42730d5d8c002f.svg";
export { ForwardRef as ReactComponent };